export const en = {
    "save": "Save",
    "general-info": "General information",
    "unknown-error": "An error has occurred",
    "form-error": "Errors were encountered while validating the form.",
    "note-for-moderator-caption": "Enter a test account to validate the authorization in the skill. If the skill requires certain devices, describe them, and the Dialog team will ask you for these devices when checking.",
    "package-name-error": "Incorrect package name",
    "select-age-restriction": "Select age restriction",
    "developer-name": "Developer name",
    "select-category": "Select category",
    "info-to-upload": "To upload files, move them to the area or click on it.",

    "add": "Add",
    "add-target-platforms": "Add platforms",
    "about": "About the application",
    "app-name-title": "Application Name",
    "app-name-description": "Short application name. It will be displayed in the app store",
    "app-name-placeholder": "Application Name",
    "short-description-title": "Short Description",
    "short-description-description": "Short application description. It will be displayed in the app store",
    "short-description-placeholder": "Description",
    "design": "Design",
    "description-title": "Description",
    "description-description": "Detailed text about what the application is and what it is for. It will be displayed on the application's page in the app store.",
    "description-placeholder": "Description up to 4000 characters",
    "drag-files-here": "Drag 'n' drop some files here, or click to select files",
    "drop-files-here": "Drop the files here ...",
    "category-title": "Category",
    "category-placeholder": "Select a suitable category",
    "age-restriction-title": "Age Restriction",
    "age-restriction-description": "Value from 0 (no restrictions) to 18. It will be displayed in the app store.",
    "age-restriction-placeholder": "Select age restriction",
    "application": "Application",
    "company-title": "Company",
    "company-description": "Name of the company that made the application. It will be displayed in the app store",
    "company-placeholder": "Company Name",
    "packet-name-title": "Package Name",
    "packet-name-description": "in the format com.company.tv",
    "packet-name-placeholder": "com.company.tv",
    "apk-title": "APK",
    "apk-placeholder": "upload .apk",
    "resources": "Resources",
    "icon-title": "Application Icon",
    "icon-description": "Png or jpeg formats, resolution 1024x500. It will be displayed in the app store",
    "icon-placeholder": "icon",
    "secondary-icon-title": "Second icon",
    "secondary-icon-description": "Png or jpeg formats, resolution 280x200. Will be displayed on auxiliary screens, for example, on the Parental Control screen.",
    "square-icon-description": "Main icon - png or jpeg, 500×500 px.",
    "screenshots-count": "{count} of {maxCount} screenshots",
    "screenshots-title": "Screenshots",
    "screenshots-description": "Png or jpeg formats, resolution 1920x1080. Examples of application screens. They will be displayed in the app store",
    "screenshot": "Screenshot",
    "select-file": "Select File",
    "delete": "Delete",
    "delete-all": "Delete All",
    "agreement": "Agreements",
    "eula-title": "EULA User Agreement",
    "eula-description": "Link to user agreement. It will be displayed in the app store.",
    "eula-placeholder": "Add a link",
    "private-policy-title": "Privacy Policy",
    "private-policy-description": "HTML file with the text of the privacy policy. It will be displayed in the app store.",
    "private-policy-placeholder": "Add a link",
    "target-platforms-description": "The application will be displayed in the catalog, and any user can activate it",
    "load-here": "Load here",
    "has-monetization": "My app has monetization",
    "has-monetization-description": "If the app has monetization, the developer needs to agree on the terms by contacting Yandex.Dialogs representatives. [Learn more]",
    "yes": "Yes",
    "no": "No",
    "voice-control-title": "Voice Control",
    "voice-control-label": "Enable voice control for the application",
    "voice-control-description": "BETA Testing Phase for the Technology. Private apps only. \nUsers will be able to control the application by voice. Alice will read and process the screen of this application on the user's device.",
    "voice-control-description-advanced": "Enable voice control technology. For more details, see the [Documentation].",
    "voice-control-apply-beta": "Apply for BETA testing to enable voice control technology. Learn more in the [Documentation].",
    "voice-control-subtitle": "Provides the ability to interact with the application using voice. Alice processes the screens and simulates clicking on interactive elements. The effectiveness of the function depends on the a11y markup of the application. There are no guarantees of stable operation of the functionality.",
    "voice-control-advanced-label": "Advanced voice control support is available.",
    "voice-control-advanced-subtitle": "The catalog marks: the application supports voice control. The application must comply with the [standards for voice commands] and undergo voice control moderation."
} as const;
export const ru = {
    "save": "Сохранить",
    "general-info": "Основная информация",
    "unknown-error": "Произошла ошибка",
    "form-error": "При проверке формы обнаружены ошибки.",
    "note-for-moderator-caption": "Укажите тестовый аккаунт для проверки авторизации в навыке. Если для работы навыка необходимы определенные устройства, опишите их, и команда Диалогов запросит эти устройства у вас при проверке.",
    "package-name-error": "Введен некорректный package name",
    "select-age-restriction": "Выберите возрастное ограничение",
    "developer-name": "Имя разработчика",
    "select-category": "Выбрать категорию",
    "info-to-upload": "Для загрузки файлов переместите их в область или нажмите на нее.",

    "add": "Добавить",
    "add-target-platforms": "Добавить платформы",
    "about": "О приложении",
    "app-name-title": "Название приложения",
    "app-name-description": "Короткое название приложения. Оно будет отображаться в магазине приложений",
    "app-name-placeholder": "Название приложения",
    "short-description-title": "Короткое описание",
    "short-description-description": "Короткое описание приложения. Оно будет отображаться в магазине приложений",
    "short-description-placeholder": "Описание",
    "design": "Оформление",
    "description-title": "Описание",
    "description-description": "Развернутый текст о том, что это за приложение и для чего оно предназначено, оно будет отображаться в магазине приложений на странице приложения.",
    "description-placeholder": "Описание до 4000 символов",
    "drag-files-here": "Перетащите файлы сюда или нажмите, чтобы выбрать файлы",
    "drop-files-here": "Поместите файлы сюда ...",
    "category-title": "Категория",
    "category-placeholder": "Выберите подходящую категорию",
    "age-restriction-title": "Возрастное ограничение",
    "age-restriction-description": "Значение от 0(без ограничений) до 18, оно будет отображаться в магазине приложений.",
    "age-restriction-placeholder": "Выберите возрастное ограничение",
    "application": "Приложение",
    "company-title": "Компания",
    "company-description": "Наименование компании, сделавшей приложение. Оно будет отобрадаться в магазине приложений",
    "company-placeholder": "Название компании",
    "packet-name-title": "Имя пакета",
    "packet-name-description": "в формате com.company.tv",
    "packet-name-placeholder": "com.company.tv",
    "apk-title": "APK",
    "apk-placeholder": "загрузите .apk",
    "resources": "Ресурсы",
    "icon-title": "Иконка приложения",
    "icon-description": "Png или jpeg форматы, разрешение 1024x500. Она будет отображаться в магазине приложений",
    "icon-placeholder": "иконка",
    "secondary-icon-title": "Вторая иконка",
    "secondary-icon-description": "Png или jpeg форматы, разрешение 280x200. Будет отображаться на вспомогательных экранах, например на экране Родительского контроля",
    "square-icon-description": "Главная иконка - png или jpeg, разрешение 500×500 пикселей.",
    "screenshots-count": "{count} из {maxCount} скриншотов",
    "screenshots-title": "Скриншоты",
    "screenshots-description": "Png или jpeg форматы, разрешение 1920x1080. Примеры экранов приложения. Они будут отображаться в магазине приложений",
    "screenshot": "Скриншот",
    "select-file": "Выбрать файл",
    "delete": "Удалить",
    "delete-all": "Удалить все",
    "agreement": "Соглашения",
    "eula-title": "Пользовательское соглашение EULA",
    "eula-description": "Ссылка на пользовательское соглашения. Он будет отображаться в магазине приложений.",
    "eula-placeholder": "Добавьте ссылку",
    "private-policy-title": "Политика конфиденциальности",
    "private-policy-description": "HTML файл с текстом политики конфиденциальности. Он будет отображаться в магазине приложений.",
    "private-policy-placeholder": "Добавьте ссылку",
    "target-platforms-description": "Приложение будет отображаться в каталоге, его сможет активировать любой пользователь",
    "load-here": "Загрузить",
    "has-monetization": "В моем приложении есть монетизация",
    "has-monetization-description": "Если в приложении есть монетизация, разработчику необходимо согласовать условия, связавшись с представителями Яндекс.Диалогов. [Подробнее]",
    "yes": "Да",
    "no": "Нет",
    "voice-control-title": "Голосовое управление",
    "voice-control-label": "Включить голосовое управление приложением",
    "voice-control-description": "BETA-Тестирование технологии. Доступно только для приватных приложений.\nПользователи смогут управлять приложением голосом. Алиса будет считывать и обрабатывать экран этого приложения на устройстве пользователя",
    "voice-control-description-advanced": "Подключите технологию голосового управления. Подробнее в [Документации].",
    "voice-control-apply-beta": "Подайте заявку на BETA тестирование, чтобы подключить технологию голосового управления. Подробнее в [Документации]",
    "voice-control-subtitle": "Предоставляет возможность взаимодействия с приложением голосом. Алиса обрабатывает экраны и имитирует нажатие на интерактивные элементы. Эффективность работы функции зависит от a11y-разметки приложения. Гарантий стабильной работы функционала нет.",
    "voice-control-advanced-label": "Поддержка продвинутого голосового управления",
    "voice-control-advanced-subtitle": "Помечает в каталоге: приложение поддерживает голосовое управление. Приложение должно соответствовать [стандартам голосовых команд] и проходит модерацию голосового управления."
} as const;
